import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface InteriorTrimsDoorsMirrorsProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const InteriorTrimsDoorsMirrors: React.FC<InteriorTrimsDoorsMirrorsProps> = ({
    required = false,
    propertyGuid,
    isReview = false,
}) => {
    const [interiorTrimsDoorsMirrors, set_interiorTrimsDoorsMirrors] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Interior Finishes']?.['Interior Trims, Doors and Mirrors'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior Finishes': { ...b.values?.['Interior Finishes'], 'Interior Trims, Doors and Mirrors': v } } })
    );
    const label = 'Interior Trims, Doors and Mirrors';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(interiorTrimsDoorsMirrors)}
                />
            ) : (
                <MoneyBox
                    id={'interiorTrimsDoorsMirrors'}
                    allowNegative={false}
                    value={interiorTrimsDoorsMirrors}
                    onChange={(value) => set_interiorTrimsDoorsMirrors(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
